import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { Subscription, take, finalize } from 'rxjs';
import { AfericaoOperacionalService } from 'src/app/modules/services/afericao-operacional/afericao-operacional.service';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { AnalyzeDetailComponent } from 'src/app/modules/shared/modals/analyze-detail/analyze-detail.component';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { AlertComponent } from '../../alert/alert.component';
import { LoadingService } from '../../loading/loading.service';
import { Status } from 'src/app/modules/shared/interface/status-filter.interface';

@Component({
  selector: 'app-afericao-operacional',
  templateUrl: './afericao-operacional.component.html',
  styleUrls: ['./afericao-operacional.component.scss']
})
export class AfericaoOperacionalComponent {
   selectedTabAfericoesIndex: number = 0;
    buttonInclusaoDisabled: boolean = false;
    buttonEdicaoDisabled: boolean = false;
    buttonExclusaoDisabled: boolean = false;
    dataSource = new MatTableDataSource<any>([]);
    displayedColumns: string[] = [];
    sortState = {
      sortProperty: 'criadoEm',
      sortDirection: 'desc'
    };
    formAfericaoOperacional!: FormGroup;
    columnConfig = [
      { columnDef: 'contrato', header: 'Contrato', property: 'contrato.contractNumber', customTd: true },
      { columnDef: 'relatorio', header: 'Nome do relatório', property: 'relatorioVinculado.nome' },
      { columnDef: 'tipoRelatorio', header: 'Tipo do relatório', property: 'tipoRelatorioVinculado.nome' },
      { columnDef: 'itemContratual', header: 'Item contratual', property: 'itemContratual' },
      { columnDef: 'periodoReferencia', header: 'Período de Referência', property: 'periodoReferenciaInicio',customTd: true },
      { columnDef: 'prazo', header: 'Prazo', property: 'prazo', customTd: true },
      { columnDef: 'afericao', header: 'Aferição/Ciência', property: 'dataAfericao', customTd: true },
      { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
      { columnDef: 'actions', header: 'Ações', custom: true }
    ];
    arrayStatus: any = [
      { label: "Pendente de comprovação", property: "", selected: false },
      { label: "Comprovação enviada", property: "", selected: false },
      { label: "Em análise", property: "", selected: false },
      { label: "Parâmetro atestado", property: "", selected: false },
      { label: "Aguardando complementação das informações", property: "", selected: false },
    ]
    canEdit: boolean = true;
    canDelete: boolean = true;
    pageIndex: number = 0;
    pageSize: number = 10;
    totalPages: number = 1;
    totalElements: number = 0;
    subsctiptions: Subscription[] = [];
    criterios: any = [];
    criteriosLabels!: { [key: string]: string; };
    filterData: any;
    screenWidth: number = window.innerWidth;
    filterTextValue: string = '';
    statusFilter: any
    statusTransition: any;
    idEntidade: any;
    idAfericao: any;
    idDocumentoComprovacao: any;
    transicaoId: any;
    statusAtualId: any;
    currentRoute: string = '';
    listaStatus: Status[] = [];
    constructor(
      private afericaoOperacionalService: AfericaoOperacionalService,
      private pageSizeService: PageSizeService,
      private pageStateService: PageStateService,
      private modalCtrl: ModalController,
      public dialog: MatDialog,
      private loadingService: LoadingService,
      private _snackBar: MatSnackBar,
      private fb: FormBuilder,
      private router: Router,
      public toastService: ToastService,
      private authService: AuthService,
      private userService: UserService,
    ) {
      this.currentRoute = this.router.url;
      this.formAfericaoOperacional = this.fb.group({
        nomeRelatorio: [''],
        nomeTipoRelatorio: [''],
        itemContratual: [''],
        prazoInicio: [''],
        prazoFim: [''],
        dataAfericaoInicio: [''],
        dataAfericaoFim: [''],
        contractName: ['']
      });
      this.buildCriteriosLabels();
      this.loadUserInfo();
    }
  
    loadUserInfo() {
      const userId = this.authService.getUserIdFromToken();
      if (userId) {
        this.userService.getMenuUsuario(userId).subscribe((response: any) => {
          const functionalities = response.profileUser.permissaoPerfis;
  
          functionalities.forEach((permission: any) => {
            this.checkFunctionality(permission.funcionalidade);
          });
        });
      }
    }
    checkFunctionality(functionality: any) {
      if (functionality.url === this.currentRoute) {
        this.handleRestrictions(functionality.restricoes);
      }
  
      if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
        functionality.subFuncionalidades.forEach((subFunctionality: any) => {
          this.checkFunctionality(subFunctionality);
        });
      }
    }
    handleRestrictions(restrictions: any[]) {
      restrictions.forEach((restriction: { nome: any; }) => {
        switch (restriction.nome) {
          case 'Inclusão':
            this.buttonInclusaoDisabled = true;
            break;
          case 'Exclusão':
            this.buttonExclusaoDisabled = true;
            break;
          case 'Edição':
            this.buttonEdicaoDisabled = true;
            break;
        }
      });
    }
  
    private buildCriteriosLabels() {
      this.criteriosLabels = {
        nomeRelatorio: 'Relatório',
        prazoInicio: 'Prazo Início',
        prazoFim: 'Prazo Fim',
        dataAfericaoInicio: 'Afericao/Ciencia Início ',
        dataAfericaoFim: 'Afericao/Ciencia Fim',
        contractName: 'Contrato',
        nomeTipoRelatorio: 'Tipo Relatório',
        itemContratual: 'Item Contratual',
        situacaoPrazo:'Situação prazo'
      };
  
    }
    ngOnInit(): void {
      this.displayedColumns = this.columnConfig.map(col => col.columnDef);
      const savedPageIndex = this.pageStateService.getPageState(this.router.url);
      if (savedPageIndex) {
        this.pageIndex = savedPageIndex;
      }
      this.getFilterOptions();
    }
    getData(pageIndex: number = 0) {
      this.loadingService.showLoading();
      this.afericaoOperacionalService.getAfericaoOperacionais(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.filterTextValue,
        this.filterData,
        this.statusFilter,
      ).subscribe((resp: any) => {
        this.loadingService.hideLoading();
        const { content, pageSize, totalPages, totalElements, pageNumber } = resp;
        this.dataSource.data = content;
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
        this.pageIndex = pageNumber;
  
      })
    }
    getFilterOptions(){
      this.afericaoOperacionalService.getFilterOptions().subscribe((resp: any) => {
        this.listaStatus = resp;
        this.statusFilter = this.listaStatus.filter(item => item.selecionado);
        this.getData(this.pageIndex);
    })
  }
    pageChangeEvent(event: PageEvent) {
      if (this.pageSize !== event.pageSize) {
        this.pageSize = event.pageSize;
        this.pageSizeService.setPageSize(event.pageSize);
        return this.getData(0);
      }
  
      if (this.pageIndex !== event.pageIndex) {
        return this.getData(event.pageIndex);
      }
    }
  
    onSortChange(sortProperty: any): void {
      if (this.sortState.sortProperty === sortProperty) {
        this.sortState.sortDirection =
          this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortState.sortProperty = sortProperty;
        this.sortState.sortDirection = 'asc';
      }
      this.getData();
    }
    openSnackBar(description: string, type: string) {
      let classSnack = '';
      switch (type) {
        case 'sucess':
          classSnack = 'snacbar-sucess';
          break;
        case 'warning':
          classSnack = 'snacbar-warning';
          break;
        case 'error':
          classSnack = 'snacbar-error';
          break;
      }
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description: description, type: type },
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
    redirectToDetailPage(id: number): void {
      // lógica para redirecionar para visualização
      this.router.navigate([`detail-afericao-operacional/${id}`]);
    }
  
    openActivateDialog(id: number): void {
      // lógica para ativar contrato
    }
  
    openInactivateDialog(id: number): void {
      // lógica para inativar contrato
    }
    applyFilter(filterValue: string) {
      this.filterTextValue = filterValue;
      this.getData();
    }
    openModalFilters(popover?: any) {
  
      let props;
      if (this.filterData) {
        props = this.filterData;
      } else {
        props = this.generatePropsFromForm(this.formAfericaoOperacional);
      }
  
      const data = {
        type: 'afericaoOperacional',
        propsAfericaoOperacional: props
      };
  
      const dialogRef = this.dialog.open(ModalFiltersComponent, {
        panelClass: ['filter-panel'],
        data,
      });
  
      dialogRef.afterClosed().subscribe({
        next: (data: any) => {
          if (data) {
            // Atualiza os critérios com base nos dados do modal
            this.filterData = data;
            this.criterios = this.getCriterios(data);
           
            if(data?.value?.idsMunicipios?.length == 0){
              this.criterios = this.criterios.filter((item: any) => item !== 'idsMunicipios')
            }
            this.getData();
          }
        }
      });
    }
    // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
    private generatePropsFromForm(form: FormGroup): any {
      const props: any = {};
      // Itera sobre os controles do FormGroup
      Object.keys(form.controls).forEach((controlName: string) => {
        const control = form.get(controlName);
  
        // Verifica se o controle tem valor e não é nulo ou vazio
        if (control && control.value !== null && control.value !== undefined && control.value !== '') {
          props[controlName] = control.value;
        }
      });
      return props;
    }
  
    getCriterios(data: any) {
      const criterios = [];
  
      // Gera os critérios de forma dinâmica, verificando os valores dos campos
      const props: any = this.generatePropsFromForm(data);
  
      for (const prop in props) {
        if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
          criterios.push(prop);
        }
      }
  
      return criterios;
    }
    criterioRemoved(event: any) {
  
  
      // Lógica para remover da lista de critérios, se necessário
      this.filterData.patchValue({
        [event.criterio]: null
      });
      this.criterios = this.criterios.filter((c: any) => c !== event.criterio);
      this.getData();
    }
    filterStatusChanged(event: {}) {
      this.statusFilter = event;
      this.getData();
    }
    transitionStatusChanged(event: any): void {
      if (!event || !event.data || !event.data.contrato || !event.data.contrato.company) {
        console.warn('Evento inválido:', event);
        return;
      }
  
      this.statusTransition = event;
  
      const idEntidade = event.data.contrato.company.id;
      const idAfericao = event.data.id;
      const transicaoId = event.transicaoId;
      const statusAtualId = event.data.status?.statusAtual?.id;
      const transicaoNome = event.transicaoNome;
      this.idAfericao = idAfericao;
      this.idEntidade = idEntidade;
      this.transicaoId = transicaoId;
      this.statusAtualId = statusAtualId;
      const transicaoStatusRequestData = {
        idExterno: idAfericao,
        idStatusAtual: statusAtualId,
        idTransicao: transicaoId,
      };
      const formData = new FormData();
      formData.append('request', new Blob([JSON.stringify(transicaoStatusRequestData)], { type: 'application/json' }));
      switch (event.transicaoNome) {
        case 'Enviar comprovação':
          this.router.navigate([
            `documento-comprovacao/${'afericao-operacional'}/${idEntidade}/${idAfericao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
          ]);
          break;
  
        case 'Encaminhar para análise':
          this.openAnalyzeDialog(idEntidade, transicaoNome);
          break;
  
        case 'Solicitar complementação':
          this.router.navigate([
            `documento-comprovacao/${'afericao-operacional'}/${idEntidade}/${idAfericao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
          ]);
          break;
  
        case 'Atestar parâmetro':
          this.router.navigate([
            `documento-comprovacao/${'afericao-operacional'}/${idEntidade}/${idAfericao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
          ]);
          break;
  
        default:
          console.warn('Ação de transição não reconhecida:', event);
          break;
      }
    }
    openAnalyzeDialog(idEntidade: string, transicaoNome: string): void {
      const dialogRef = this.dialog.open(AnalyzeDetailComponent, {
        width: '1350px',
        data: {
          protocolNumber: '010203040506070809',
          idEntidade: idEntidade, // se quiser já trazer um protocolo existente,
          transicaoNome: transicaoNome,
          idAfericao: this.idAfericao,
          from: 'afericao-operacional'
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.transitionStatusComplete(this.idAfericao, this.statusAtualId, this.transicaoId, result.data, result.idDocumentoComprovacao);
        }
      });
    }
    transitionStatusComplete(idAfericao: any, idStatusAtual: any, transicaoId: any, data?: any, idDocumentoComprovacao?: any,) {
      let analiseAfericao: any = [];
  
      const analisesAfericao = Array.from(data.entries());
      analisesAfericao.forEach(([protocolo, analise]: any) => {
        const itensSelecionados = analise.items
          .filter((item: any) => item.selected)
          .map((item: any) => ({
            idTipoAnalise: item.id,
            descricao: item.description,
            idUsuario: item.responsibleId,
            prazo: item.dueDate ? moment(item.dueDate).format('YYYY-MM-DD') : ''
          }));
  
        if (itensSelecionados.length > 0) {
          if (protocolo.includes('Gerando')) {
            analiseAfericao.push({
              itensAnalise: itensSelecionados
            });
          } else {
  
            analiseAfericao.push({
              idDocumentoComprovacao: idDocumentoComprovacao,
              itensAnalise: itensSelecionados
            });
          }
  
        }
      });
  
      const resultadoFinal = {
        analise: {
          analiseAfericao: analiseAfericao
        }
      };
  
      const transicaoStatusRequestData = {
        idExterno: idAfericao,
        idStatusAtual: idStatusAtual,
        idTransicao: transicaoId,
        analise: resultadoFinal.analise
      };
      const formData = new FormData();
      formData.append('request', new Blob([JSON.stringify(transicaoStatusRequestData)], { type: 'application/json' }));
      this.loadingService.showLoading();
      this.afericaoOperacionalService.postTransicaoStatus(formData).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe(
        (response: any) => {
          this.getData(0);
          this.toastService.showSuccess('Mudança de status realizada com sucesso');
        },
        (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      );
    }
  
    // === ENVIO DE TRANSIÇÃO DE STATUS ===
    transitionStatus(formData?: any): void {
      this.loadingService.showLoading();
  
      this.afericaoOperacionalService.postTransicaoStatus(formData)
        .pipe(
          take(1),
          finalize(() => this.loadingService.hideLoading())
        )
        .subscribe({
          next: () => {
            this.getData(0);
            this.toastService.showSuccess('Mudança de status realizada com sucesso');
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        });
    }
 }
